import Axios from 'api/client';
import { Tag } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

const DEFAULT_TAG_TYPE = 'contact';

interface AddTagsParams {
    type?: string;
    tags: string[];
}

interface FetchTagsParams extends FilterParams {
    labels?: string[];
    with_objects?: boolean;
    type?: string;
}

interface MergeTagsObject {
    name: string;
    tag_ids: number[];
    type: string;
}

interface UpdateTagParams {
    id: number;
    name: string;
    type?: string;
}

export const fetchTags = (accountId: number, params = {} as FetchTagsParams) =>
    Axios.get<PaginatedData<Tag>>(`/accounts/${accountId}/tags`, {
        params: { ...params, type: params.type ?? DEFAULT_TAG_TYPE, limit: params.limit ?? 9999 },
    }).then(response => response.data);

export const fetchTagById = (accountId: number, tagId: number) =>
    Axios.get<Tag>(`/accounts/${accountId}/tags/${tagId}`).then(response => response.data);

export const deleteTagById = (accountId: number, tagId: number) =>
    Axios.delete(`/accounts/${accountId}/tags/${tagId}`);

export const createTags = (accountId: number, { tags, type = DEFAULT_TAG_TYPE }: AddTagsParams) =>
    Axios.post<Tag[]>(`/accounts/${accountId}/tags`, { tags, type });

export const updateTagById = (
    accountId: number,
    { id, name, type = DEFAULT_TAG_TYPE }: UpdateTagParams,
) =>
    Axios.patch<Tag>(`/accounts/${accountId}/tags/${id}`, {
        name,
        type,
    });

export const mergeTags = (accountId: number, params: MergeTagsObject) =>
    Axios.post(`/accounts/${accountId}/tags/merge`, params);

export type { FetchTagsParams };
